import { indexdDbWrapper } from './indexdDB';
import { generateUUID, isIOS } from '@/tools/helpers';

// ##################
let timeSyncUrl = 'https://time.cms.shoutrlabs.com'; // this is overwritten with [datasourceURL]/time.php
const maxSyncAttempts = 20; // Attempts to request time from sync server.
// const minSyncAttempts = 6;
const maxRountripDurationInit = 0.2; // in s; Max accepted time for a roundtrip for requesting the time from the sync server.
const maxRountripDurationStep = 0.3; // seconds to increase duration if sync fails
const maxRountripDurationMax = 1.0; // absolute max rountrip duration in s
let maxRountripDuration = maxRountripDurationInit;
// const percentTimeCorrectionCloseToMedian = 0.2; // percentage that time correction is allowed to be away from the median
const throttleTimeLocalSeekCorrection = 500; // trottle timeupdate events that check if local time is desired time
const localMaxSyncDifferenceInit = 0.05; // in seconds; max difference of media current time to desired time
const localMaxSyncDifferenceStep = 0.05; // in seconds; max difference of media current time to desired time
let localMaxSyncDifference = localMaxSyncDifferenceInit; // in seconds; max difference of media current time to desired time
const maxLocalSyncAttempts = 30;
const maxTimeSyncErrors = 10;
// ##################

let $media = null;
let $el = null;
let $progress = null;
let audioDataLoaded = false;
let audioDataLoading = false;
let configStartTime = 2; // in seconds
let configStartTimeTimeCorrected = 2; // in seconds
let currentStartTime = 0; // in seconds
let mediaDuration = 0;
let videoStartTimeout = null;
let countDownInterval = null;
let startOffset = null;
let isLoop = false;
let delayBetweenLoop = 2; // in seconds
let initialized = false;
let syncronizing = false;
let isLoading = false;
let audioEnded = false;
let src = '';
let cacheMedia = true;
let mediaType = '';
let timeCorrection = null;
let localSync = false;

// return Date.now in seconds
function now() {
	return Date.now() / 1000;
}

function roundToMs(num) {
	return Math.round(num * 1000) / 1000;
}

// https://remysharp.com/2010/07/21/throttling-function-calls
function throttle(fn, threshhold, scope) {
	// threshhold || (threshhold = 250);
	let last;
	let deferTimer;
	return function action(...args) {
		const context = scope || this;
		const _now = +new Date();
		if (last && _now < last + threshhold) {
			// hold on to it
			clearTimeout(deferTimer);
			deferTimer = setTimeout(() => {
				last = _now;
				fn.apply(context, args);
			}, threshhold);
		} else {
			last = _now;
			fn.apply(context, args);
		}
	};
}

// function median(values) {
// 	values.sort((a, b) => a - b);
// 	const half = Math.floor(values.length / 2);
// 	if (values.length % 2) return values[half];
// 	return (values[half - 1] + values[half]) / 2.0;
// }

// FIXME replace this with vue function
function xhrGet(url) {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.open('GET', url, true);
		xhr.overrideMimeType('text/plain');
		xhr.onload = () => {
			if (xhr.status === 200) {
				resolve(xhr.response);
			} else {
				reject(new Error(`${xhr.status} ${xhr.statusText}`));
			}
		};
		xhr.onerror = () => {
			reject(new Error(`Network error ${xhr.status}`));
		};
		xhr.send();
	});
}

async function getOneSyncServerTimeCorrection() {
	const beforeFetch = now();
	const result = await xhrGet(`${timeSyncUrl}?cacheBreaker=${generateUUID()}`);
	const serverTime = parseFloat(result) / 1000; // in seconds
	const roundTripDuration = now() - beforeFetch;
	if (roundTripDuration > maxRountripDuration) {
		throw Error(`Connection to slow, rountrip took ${roundTripDuration.toFixed(2)} s.`);
	}
	return {
		roundTripDuration,
		timeCorrection: now() - serverTime - roundTripDuration / 2,
	};
}

// function filterTimeCorrectionCloseToMedian(values) {
// 	const medianTimeCorrection = median(values);
// 	return values.filter(_timeCorrection => {
// 		const difference = _timeCorrection / medianTimeCorrection;
// 		return (
// 			difference < 1 + percentTimeCorrectionCloseToMedian &&
// 			difference > 1 - percentTimeCorrectionCloseToMedian
// 		);
// 	});
// }

// function arithmeticAverage(values) {
// 	return values.reduce((acc, value) => acc + value, 0) / values.length;
// }

function sortSyncResults(a, b) {
	return a.roundTripDuration <= b.roundTripDuration ? -1 : 1;
}
// function mapTimeCorrectionValues({ timeCorrection }) {
// 	return timeCorrection;
// }

async function syncTime() {
	console.log('syncTime');
	// in seconds
	const results = [];
	let errors = 0;
	while (results.length < maxSyncAttempts) {
		try {
			results.push(await getOneSyncServerTimeCorrection());
		} catch (error) {
			console.log('time sync error', error);
			if (++errors > maxTimeSyncErrors) {
				throw new Error(`Syncronization failed. Last error: ${error}`);
			}
		}
		setProgress(Math.round(results.length / (maxSyncAttempts / 100)));
	}
	errors = 0;
	const firstN = 3;
	results.sort(sortSyncResults);
	console.log('results', results);
	const _timeCorrection =
		results.slice(0, firstN).reduce((acc, { timeCorrection }) => acc + timeCorrection, 0) / firstN;
	console.log(`_timeCorrection of first ${firstN} average ${_timeCorrection}`);
	// const _timeCorrection = results[0].timeCorrection;
	// console.log('taking shortest roundTripDuration',results[0].roundTripDuration);
	if (isNaN(_timeCorrection)) {
		throw new Error('Time correction is NaN.');
	}
	return _timeCorrection;
}

let mediaQueued = false;
function playMediaAt(_startTime) {
	console.log('playMediaAt _startTime', _startTime, 'mediaQueued', mediaQueued);
	if (mediaQueued) return;
	mediaQueued = true;
	// start time in s
	currentStartTime = _startTime;
	// $el.classList.add('active');
	if (countDownInterval) clearInterval(countDownInterval);
	if (videoStartTimeout) clearTimeout(videoStartTimeout);
	const timeToStartDiff = _startTime - now();
	if (timeToStartDiff > 0) {
		console.log('will start in the future');
		showMessage('Will start playback soon.');
		countDownInterval = setInterval(() => {
			const startDiff = _startTime - now();
			if (startDiff < 0) {
				playMedia();
				clearInterval(countDownInterval);
			}
			setProgress(100 - (startDiff / timeToStartDiff) * 100);
		}, 1000);

		videoStartTimeout = setTimeout(async () => {
			playMedia();
		}, (_startTime - now()) * 1000);
	} else {
		console.log('has already ended');
		const timeBeforeEnd = _startTime + mediaDuration - now();
		if (timeBeforeEnd > 0) {
			startOffset = roundToMs(now() - _startTime); // Start now with x second
			console.log(`Start now with ${startOffset} second`);
			playMedia();
		} else {
			console.log('calculate next start time');
			if (isLoop) {
				mediaQueued = false;
				playMediaAt(getNextStartTime());
			}
		}
	}
}

function getNextStartTime() {
	const multiplier = Math.floor((now() - configStartTimeTimeCorrected) / (mediaDuration + delayBetweenLoop));
	const nextStartTime = configStartTimeTimeCorrected + (mediaDuration + delayBetweenLoop) * multiplier;
	console.log('configStartTime', configStartTime);
	console.log('mediaDuration', mediaDuration, delayBetweenLoop);
	console.log('nextStartTime', nextStartTime - timeCorrection);
	console.log('timeCorrection', timeCorrection);
	console.log('nextStartTimeTimeCorrected', nextStartTime);
	return nextStartTime;
}

function playMedia() {
	console.log('playMedia');
	$media.play();
	mediaQueued = false;
}

async function loadAudio(src) {
	if (indexdDbWrapper.isAvailable()) {
		await indexdDbWrapper.init();
		const data = await indexdDbWrapper.read(src);
		if (data === undefined) {
			return preloadAudio(src);
		}
		console.log('loaded from cache');
		setProgress(100);
		audioDataLoaded = true;
		console.log('set obj url');
		$media.src = URL.createObjectURL(data);
		return undefined;
	}
	return preloadAudio(src);
}

function preloadAudio(src) {
	console.log('mediaSyncronization preloadAudio', src);
	return new Promise((resolve, reject) => {
		if (audioDataLoading) {
			resolve();
			return;
		}

		audioDataLoading = true;
		const xhr = new XMLHttpRequest();
		xhr.open('GET', src, true);
		// xhr.withCredentials = true;
		xhr.responseType = 'blob';
		xhr.onprogress = event => {
			if (event.lengthComputable) {
				setProgress(Math.floor((event.loaded / event.total) * 100));
				// showMessage(`… loading audio data ${Math.floor(event.loaded / event.total * 100)}%`);
			}
		};
		xhr.onload = () => {
			console.log('preloadAudio: ', xhr.status, src);
			if (xhr.status === 200) {
				audioDataLoaded = true;
				console.log('mediaSyncronization audioDataLoaded', audioDataLoaded);
				if (indexdDbWrapper.isAvailable()) {
					indexdDbWrapper.init().then(() => {
						console.log('write to indexdDB');
						indexdDbWrapper.write(src, xhr.response);
					});
				}
				console.log('set obj url2');
				$media.src = URL.createObjectURL(xhr.response);
			}
		};
		xhr.onloadend = () => {
			resolve();
		};
		xhr.onerror = error => {
			audioDataLoaded = false;
			reject(new Error(`Error downloading audio data ${error.err}`));
		};
		xhr.send();
	});
}

function onEnded() {
	console.log('onEnded isLoop audioEnded', isLoop, audioEnded);
	mediaQueued = false;
	// setTimeout(() => {
	// 	const nextStartTime = getNextStartTime();
	// 	startOffset = roundToMs(now() - nextStartTime);
	// 	console.log(`Start now with ${startOffset} second`)
	// 	playMedia();
	// 	// check if we can start a new loop
	// }, 300)
}

// If the audio is paused start it immediately again.
// This prevents stopping the audio when the headphone jack is unplugged
function onPause() {
	console.log('something paused the media playback.');
	// if (audioEnded || localSync) return;
	// playMedia()
}

async function loadAndSync() {
	console.log('loadAndSync');
	let _timeCorrection;
	if (syncronizing) {
		console.warn('mediaSyncronization already syncronizing.');
		return;
	}
	try {
		syncronizing = true;
		_timeCorrection = await syncTime();
		timeCorrection = _timeCorrection; // just for debugging
		syncronizing = false;
	} catch (error) {
		if (maxRountripDuration < maxRountripDurationMax) {
			maxRountripDuration += maxRountripDurationStep;
			showMessage('Das Synchronisieren hat nicht funktioniert. Bitte versuche es erneut.');
		} else {
			showMessage(
				'Deine Internetverbindung ist zu langsam. Bitte nimm Kontakt zum Organisationsteam auf.'
			);
		}
		console.warn(`${error}`);
		// $el.querySelector('.p_AudioSync2__resync').classList.add('p_AudioSync2__resync--active');
		_timeCorrection = 999999;
		return;
	}
	console.log('_timeCorrection', _timeCorrection);
	localSyncErrors = 0;
	// timeServerSyncErrors = 0;
	maxRountripDuration = maxRountripDurationInit;
	// Reset local max sync difference, because we may have more luck this time.
	localMaxSyncDifference = localMaxSyncDifferenceInit;
	testCount = 0;
	// const startTime = _timeCorrection + configStartTime;
	configStartTimeTimeCorrected = _timeCorrection + configStartTime;
	if (isLoading) {
		console.warn('mediaSyncronization already loading media.');
		return;
	}
	console.log('cacheMedia', cacheMedia);
	if (cacheMedia) {
		try {
			isLoading = true;
			await loadAudio(src);
			isLoading = false;
		} catch (error) {
			isLoading = false;
			showMessage('Das Laden der Audiodatei hat nicht funktioniert. Bitte versuche es erneut.');
			console.warn(`${error}`);
			// $el.querySelector('.p_AudioSync2__redownload').classList.add('p_AudioSync2__redownload--active');
			return;
		}
		if (audioDataLoaded) {
			playMediaAt(configStartTimeTimeCorrected);
		}
	} else {
		playMediaAt(configStartTimeTimeCorrected);
	}
}

function showMessage(message) {
	const _$el = $el.querySelector('.element__caption__text--description');
	if (_$el) _$el.innerHTML = message;
}

function setProgress(percent) {
	// console.log("percent", percent);
	if ($progress) $progress.style.width = `${percent}%`;
}

function setCurrentTime(diff) {
	if (isIOS || true) {
		localSync = true;
		$media.currentTime += diff;
		// $media.play().then(() => {
		// 	console.log('started playing')
		// });
		localSync = false;
	} else {
		$media.currentTime += diff;
	}
}

let lastError = null;
let testCount = 0;
let localSyncErrors = 0;
function seekToCorrectTime() {
	if ($media.paused || !audioDataLoaded) return;
	// Initial sync to offset if the media started already.
	if (startOffset) {
		$media.currentTime = startOffset;
		startOffset = null;
		return;
	}
	const diff = roundToMs(now() - currentStartTime - $media.currentTime);
	// const expectedTime = roundToMs($media.currentTime + diff);
	// if (expectedTime < 0) {
	// 	console.log("$media.currentTime - diff", $media.currentTime - diff);
	// 	$media.currentTime = 0;
	// 	return;
	// } else if (expectedTime > mediaDuration) {
	// 	console.warn("$media.currentTime + diff", $media.currentTime + diff);
	// 	return;
	// }
	// Time correct if more than 10 ms off
	// console.log("lastError", lastError);
	if (Math.abs(diff) > localMaxSyncDifference) {
		if (localSync) console.warn('time correction but localSync');
		$media.muted = true;
		console.log('diff ', diff, ' currentTime ', $media.currentTime, ' - ', now() - currentStartTime);
		if (lastError === null) {
			setCurrentTime(diff);
			localSync = false;
			lastError = diff;
		} else {
			const cumulatedDiff = diff + (diff + lastError) / 2;
			setCurrentTime(cumulatedDiff);
			lastError = cumulatedDiff;
			if (++localSyncErrors > maxLocalSyncAttempts) {
				// If there are too many errors, increase the sync differnece
				localSyncErrors = 0;
				localMaxSyncDifference = roundToMs(localMaxSyncDifference + localMaxSyncDifferenceStep);
				console.log('localMaxSyncDifference', localMaxSyncDifference);
				// showMessage(`Increase local max sync error to ${localMaxSyncDifference} s`);
			}
		}
	} else {
		if (++testCount < 5) {
			console.log('XXXX ', diff, ' currentTime ', $media.currentTime, ' - ', now() - currentStartTime);
		}
		$media.muted = false;
	}
}

export function onClickTogglePlay() {
	if (!(mediaDuration || configStartTime)) {
		throw new Error('Please edit the article, duration or start time are missing.');
	}
	if (!($media && mediaType)) {
		throw new Error('initMediaSyncElements was not called or without parameters');
	}
	$el = document.querySelector(`.ui--${mediaType}`);
	if ($el) {
		$progress = $el.querySelector('.element__progress__bar');
	} else {
		$progress = null;
		setTimeout(() => {
			$el = document.querySelector(`.ui--${mediaType}`);
			if ($el) $progress = $el.querySelector('.element__progress__bar');
		}, 700);
		console.warn(`the ${mediaType} player is not in the DOM yet, progress is missing`);
	}
	// Play and pause to circumvent playback prevention on mobile devices.
	if (!initialized) {
		const playPromise = $media.play();
		initialized = true;
		if (playPromise) {
			playPromise
				.then(() => {
					console.log('initialized pause');
					$media.pause();
				})
				.catch(error => {
					console.warn('onClickTogglePlay playPromise failed', error);
				});
		} else {
			setTimeout(() => {
				console.log('timeout pause');
				$media.pause();
			}, 10);
		}
	}
	// Pause playback if currently playing.
	else if ($media && !$media.paused) {
		console.log('on click pause');
		$media.pause();
		$el.classList.remove('active');
		showMessage('Press play to resynchronize and start playing.');
		return;
	}
	loadAndSync();
}

function onCanPlay() {
	audioDataLoaded = true;
}
const throttledSeekToCorrectTime = throttle(seekToCorrectTime, throttleTimeLocalSeekCorrection);

export function initMediaSync(options) {
	({ $el, $media, $progress, src, mediaType } = options);
	const { startPlaying } = options;
	// if (dataSourceURL) {
	// 	timeSyncUrl = `${dataSourceURL}time.php`;
	// 	// FIXME must test if the resource is online or fallback to time.cms.shoutrlabs.com
	// }
	timeSyncUrl = 'http://10.0.0.1:10042/time.php';
	// cacheMedia = options.cacheMedia !== undefined ? options.cacheMedia : true;
	cacheMedia = false; // FIXME for now only cached works since seek will always jump to currentTime 0 if not cached
	// Time correction also shows the time, this should not be visible during syncronization.
	$media.addEventListener('timeupdate', throttledSeekToCorrectTime);
	$media.addEventListener('ended', onEnded);
	$media.addEventListener('pause', onPause);
	// If seeking to time starts before canplay is fired the media resets to the start and will not play.
	if (!cacheMedia) $media.addEventListener('canplay', onCanPlay);
	({ mediaDuration, isLoop = true, delayBetweenLoop = 1 } = options);
	const dayStart = new Date();
	dayStart.setHours(0, 0, 0, 1);
	configStartTime = dayStart.getTime() / 1000; // convert to seconds
	console.log('configStartTime', configStartTime);
	mediaDuration = 244.323; // FIXME dirty hack for Exponatec19
	// mediaDuration = roundToMs(mediaDuration) // round to millisecond precision
	if (startPlaying) onClickTogglePlay();
}

export function unSync() {
	console.log('mediaSyncronization unSync');
	$media.removeEventListener('timeupdate', throttledSeekToCorrectTime);
	$media.removeEventListener('ended', onEnded);
	$media.removeEventListener('pause', onPause);
	$media.removeEventListener('canplaythrough', onCanPlay);
}
